/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-10 20:55:03
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 01:07:13
 */

import Vue from 'vue'
import Router from 'vue-router'

import Error404 from '../components/Error404'
import {router} from '@/page/index'

Vue.use(Router)

let routerCommon = [
  {
    path: '*', component: Error404
  }
]

routerCommon = routerCommon.concat(router)
export default routerCommon



// WEBPACK FOOTER //
// ./src/common/config/routerCommon.js